import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FISCAL_YEAR_API } from "./apiRoutes";

interface mutateProps {
  communityId: string | number;
  fiscalYear: string | number;
}

const mutateLockYear = async ({ communityId, fiscalYear }: mutateProps) => {
  return await axiosAuth.post(
    `${FISCAL_YEAR_API(communityId)}/${fiscalYear}/lock`
  );
};

const useLockYearMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateLockYear,
    ...queryParams,
  });

export default useLockYearMutation;
